import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from './../../../environments/environment';
import { User } from './../../models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private API_URL=environment.API_URL;
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(data:any) {
        return this.http.post<any>(this.API_URL+'/admin/login', data)
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                return user;
            }));
    }
    weblogin(data:any) {
        return this.http.post<any>(this.API_URL+'/web/login', data)
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                return user;
            }));
    }
    logout() {
        // remove user from local storage to log user out
      
        return this.http.post<any>(this.API_URL+'/admin/logout',{})
            .pipe(map(user => {
                localStorage.removeItem('currentUser');
                this.currentUserSubject.next(null);
            }));
    }
    authlogout(){
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
    permissionCheck(data:any){
        //console.log(data);
        return this.http.post(this.API_URL+'/admin/permissionCheck',data);
    }
    webForgotpassword(email:string){
        return this.http.post(this.API_URL+'/web/forgotPassword',email);
    
    }
    forgotpassword(email:string){
        return this.http.post(this.API_URL+'/admin/forgotPassword',email);
    
    }
    webResetPassword(data:any){
        return this.http.post(this.API_URL+'/web/resetPassword',data);
    }
    changePassword(data:any){
    return this.http.post(this.API_URL+'/admin/changePassword',data);
    }
    resetPassword(data:any){
    return this.http.post(this.API_URL+'/admin/resetPassword',data);
    }
    updatePassword(data:any){
    return this.http.post(this.API_URL+'/web/updatePassword',data);
    }
    isLoggedIn() {
       return this.getToken() !== null;
    }
    getToken() {
        return localStorage.getItem("LoggedInUser")
    }
}